import {AmplitudeItemListName} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";

export type AmplitudeFavouritePlacement =
    | "rp_favourite_listing_tile"
    | "rp_favourite_property_nav"
    | "rp_favourite_sidebar"
    | "rp_favourite_promo_tile"
    | "rp_favourite_configurator_tile"
    | "rp_favourite_see_apartments"
    | "rp_favourite_listing_map"
    | "rp_favourite_investment_apartments"
    | "rp_favourite_investment_page"
    | "rp_favourite_homepage";

export type AmplitudeFavouriteLocation =
    | "property_page"
    | "investment_page"
    | "listing_page"
    | "rp_see_apartments"
    | "listing_map"
    | "homepage"
    | "property_configurator";

export type AmplitudeFavouriteItemCategory = "property" | "investment";

export type AmplitudeFavouriteListView = "floor_plans" | "list";

export interface IAmplitudeFavouriteOffer {
    id: number;
    name?: string | null;
    vendorName?: string | null;
    address?: string | null;
}

export interface IAmplitudeFavouriteProperty {
    id: number;
    number?: string | null;
    area?: number | null;
    rooms?: number | null;
    floor?: number | null;
    price?: number | null;
    pricePerSquareMeter?: number | null;
    currency?: string | null;
}

export interface IAmplitudeFavouriteListContext {
    itemListId?: string | null;
    itemListName?: AmplitudeItemListName | null;
    listView?: AmplitudeFavouriteListView | null;
    index?: number | null;
}

export interface IAmplitudeFavouritesEventParams {
    location: AmplitudeFavouriteLocation;
    favouritePlacement: AmplitudeFavouritePlacement;
    offer: IAmplitudeFavouriteOffer;
    property?: IAmplitudeFavouriteProperty | null;
    listContext?: IAmplitudeFavouriteListContext;
}

export const getAmplitudeFavouritesEventProperties = (params: IAmplitudeFavouritesEventParams): Record<string, unknown> => {
    const {location, favouritePlacement, offer, property, listContext} = params;
    const itemCategory: AmplitudeFavouriteItemCategory = property ? "property" : "investment";

    return {
        location,
        favourite_placement: favouritePlacement,
        item_id: offer.id,
        property_id: property?.id ?? null,
        item_category: itemCategory,
        item_name: offer.name ?? null,
        item_brand: offer.vendorName ?? null,
        item_address: offer.address ?? null,
        price: property?.price ?? null,
        price_m2: property?.pricePerSquareMeter ?? null,
        currency: property?.price != null ? (property.currency ?? "PLN") : null,
        variant_name: property?.number ?? null,
        variant_area: property?.area ?? null,
        variant_rooms: property?.rooms ?? null,
        variant_floor: property?.floor ?? null,
        item_list_id: listContext?.itemListId ?? null,
        item_list_name: listContext?.itemListName ?? null,
        list_view: listContext?.listView ?? null,
        index: listContext?.index ?? null
    };
};
import {AmplitudeItemListName} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";

export type AmplitudeFavouritePlacement =
    | "rp_favourite_listing_tile"
    | "rp_favourite_property_nav"
    | "rp_favourite_sidebar"
    | "rp_favourite_promo_tile"
    | "rp_favourite_configurator_tile"
    | "rp_favourite_see_apartments"
    | "rp_favourite_listing_map"
    | "rp_favourite_investment_apartments"
    | "rp_favourite_investment_page"
    | "rp_favourite_homepage";

export type AmplitudeFavouriteLocation =
    | "property_page"
    | "investment_page"
    | "listing_page"
    | "rp_see_apartments"
    | "listing_map"
    | "homepage"
    | "property_configurator";

export type AmplitudeFavouriteItemCategory = "property" | "investment";

export type AmplitudeFavouriteListView = "floor_plans" | "list";

export interface IAmplitudeFavouriteOffer {
    id: number;
    name?: string | null;
    vendorName?: string | null;
    address?: string | null;
}

export interface IAmplitudeFavouriteProperty {
    id: number;
    number?: string | null;
    area?: number | null;
    rooms?: number | null;
    floor?: number | null;
    price?: number | null;
    pricePerSquareMeter?: number | null;
    currency?: string | null;
}

export interface IAmplitudeFavouriteListContext {
    itemListId?: string | null;
    itemListName?: AmplitudeItemListName | null;
    listView?: AmplitudeFavouriteListView | null;
    index?: number | null;
}

export interface IAmplitudeFavouritesEventParams {
    location: AmplitudeFavouriteLocation;
    favouritePlacement: AmplitudeFavouritePlacement;
    offer: IAmplitudeFavouriteOffer;
    property?: IAmplitudeFavouriteProperty | null;
    listContext?: IAmplitudeFavouriteListContext;
}

export const getAmplitudeFavouritesEventProperties = (params: IAmplitudeFavouritesEventParams): Record<string, unknown> => {
    const {location, favouritePlacement, offer, property, listContext} = params;
    const itemCategory: AmplitudeFavouriteItemCategory = property ? "property" : "investment";

    return {
        location,
        favourite_placement: favouritePlacement,
        item_id: offer.id,
        property_id: property?.id ?? null,
        item_category: itemCategory,
        item_name: offer.name ?? null,
        item_brand: offer.vendorName ?? null,
        item_address: offer.address ?? null,
        price: property?.price ?? null,
        price_m2: property?.pricePerSquareMeter ?? null,
        currency: property?.price != null ? (property.currency ?? "PLN") : null,
        variant_name: property?.number ?? null,
        variant_area: property?.area ?? null,
        variant_rooms: property?.rooms ?? null,
        variant_floor: property?.floor ?? null,
        item_list_id: listContext?.itemListId ?? null,
        item_list_name: listContext?.itemListName ?? null,
        list_view: listContext?.listView ?? null,
        index: listContext?.index ?? null
    };
};
